// Images (R3): the header images of WhatsApp templates, uploaded once and picked per campaign (the daily image, A7).
// JPG, PNG or WebP, at most 5 MB. The backend keeps the file (like the voice files) and serves it by a public URL that
// Exotel and Meta can fetch; the approver sees the picked image on the summary.
import { z } from 'zod'
import { Id, IsoDateTime } from './common'

export const ImageFormat = z.enum(['jpg', 'png', 'webp'])
export type ImageFormat = z.infer<typeof ImageFormat>
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024

export const MediaImage = z.object({
  id: Id,
  name: z.string(),
  format: ImageFormat,
  size_bytes: z.number().int().min(1),
  width: z.number().int().min(1),
  height: z.number().int().min(1),
  url: z.string().describe('where it is served from (the mock: a small preview made in the browser)'),
  uploaded_by_name: z.string(),
  uploaded_at: IsoDateTime,
  used_by: z.array(z.string()).describe('the campaigns whose WhatsApp header is this image'),
})
export type MediaImage = z.infer<typeof MediaImage>

/** The file as the browser read it, with a small preview (the file itself goes up with it on the backend, W2). */
export const UploadImageInput = z.object({
  name: z.string().trim().min(3, 'Give it a name, e.g. Diwali offer banner').max(60),
  format: ImageFormat,
  size_bytes: z.number().int().min(1).max(MAX_IMAGE_BYTES, 'At most 5 MB'),
  width: z.number().int().min(1),
  height: z.number().int().min(1),
  preview: z.string().regex(/^data:image\//, 'Pick an image'),
})
export type UploadImageInput = z.infer<typeof UploadImageInput>

export interface ImagesApi {
  listImages(): Promise<MediaImage[]>
  /** the backend takes the file itself (W2); the mock keeps the preview only */
  uploadImage(input: UploadImageInput, file?: Blob): Promise<MediaImage>
  /** refused while a campaign that is not finished uses it */
  deleteImage(id: string): Promise<void>
}
